import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/common/Navbar';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import PlanningPage from './pages/PlanningPage';
import InterventionDetailPage from './pages/InterventionDetailPage';
import HeuresPage from './pages/HeuresPage';
import ProfilPage from './pages/ProfilPage';
import GestionPage from './pages/GestionPage';
import BeneficiaireDetailPage from './pages/BeneficiaireDetailPage';

// Route protégée
const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

// Layout avec navbar
const LayoutWithNavbar = ({ children }) => {
  return (
    <>
      {children}
      <Navbar />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          
          <Route
            path="/"
            element={
              <PrivateRoute>
                <LayoutWithNavbar>
                  <HomePage />
                </LayoutWithNavbar>
              </PrivateRoute>
            }
          />
          
          <Route
            path="/planning"
            element={
              <PrivateRoute>
                <LayoutWithNavbar>
                  <PlanningPage />
                </LayoutWithNavbar>
              </PrivateRoute>
            }
          />
          
          <Route
            path="/intervention/:id"
            element={
              <PrivateRoute>
                <LayoutWithNavbar>
                  <InterventionDetailPage />
                </LayoutWithNavbar>
              </PrivateRoute>
            }
          />
          
          <Route
            path="/heures"
            element={
              <PrivateRoute>
                <LayoutWithNavbar>
                  <HeuresPage />
                </LayoutWithNavbar>
              </PrivateRoute>
            }
          />
          
          <Route
            path="/profil"
            element={
              <PrivateRoute>
                <LayoutWithNavbar>
                  <ProfilPage />
                </LayoutWithNavbar>
              </PrivateRoute>
            }
          />
          
          <Route
            path="/gestion"
            element={
              <PrivateRoute>
                <LayoutWithNavbar>
                  <GestionPage />
                </LayoutWithNavbar>
              </PrivateRoute>
            }
          />
          
          <Route
            path="/beneficiaire/:id"
            element={
              <PrivateRoute>
                <LayoutWithNavbar>
                  <BeneficiaireDetailPage />
                </LayoutWithNavbar>
              </PrivateRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;